import axiosInstance from "../api";
import { notification } from "antd";

// getRecommendatedDestination
export const getCategoryList = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/get_question_category?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching data",
      description:
        response?.data?.message || "Failed to fetch data list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching data",
      description:
        error.response?.data?.message || "Failed to fetch data list.",
      duration: 3,
    });
    throw new Error("Error fetching data list");
  }
};


export const updateCategory = async (data) => {
  console.log("data -->", data)
  try {
    const formData = new FormData();
    if (data.category_name) {
      formData.append("category_name", data.category_name);
    }
    if (data.use_custom_image !== undefined) {
      formData.append("use_custom_image", data.use_custom_image);
    }
    if (data.active !== undefined) {
      formData.append("active", data.active);
    }
    if (data.image) {
      formData.append("image", data.image);
    }
    if (data.id) {
      formData.append("id", data.id);
    }
    if (data.is_delete_image !== undefined) {
      formData.append("is_delete_image", data.is_delete_image);
    }

    const response = await axiosInstance.put(
      `/update_category`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description:
          response.data.message ||
          "An error occurred while updating the category.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error updating category"
    );
  }
};


export const updateMultipleCategory = async (data) => {
  try {
  
    const response = await axiosInstance.put(
      `/update_category_custom_orders`, data);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description:
          response.data.message ||
          "An error occurred while updating category order.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
  }
};
